<template>
    <el-breadcrumb class="app-breadcrumb" separator="/">
        <transition-group name="breadcrumb">
            <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
                <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
                <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
            </el-breadcrumb-item>
        </transition-group>
    </el-breadcrumb>
</template>

<script>
    import * as pathToRegexp from 'path-to-regexp'
    export default {
        data() {
            return {
                levelList: null
            }
        },
        watch: {
            $route() {
                this.getBreadcrumb()
            }
        },
        created() {
          console.log('456');
          this.getBreadcrumb()
        },
        methods: {
            getBreadcrumb() {

                let matched = this.$route.matched.filter(item => {
                    if (item.name) {
                        return true
                    }
                })
                const first = matched[0]
                if (first && first.name.trim().toLocaleLowerCase() !== 'orders'.toLocaleLowerCase()) {
                    matched = [{path: '/orders', meta: {title: '首页'}}].concat(matched)
                }
                this.levelList = matched
              console.log('123123123123');
              console.log(this.levelList);
            },
            pathCompile(path) {
                const {params} = this.$route
                console.log('pathToRegexppathToRegexppathToRegexppathToRegexppathToRegexppathToRegexp')
                console.log(pathToRegexp);
                var toPath = pathToRegexp.compile(path)
                console.log('pathCompile$$$$$$$$')
                console.log(toPath(params))
                return toPath(params)
            },
            handleLink(item) {
                const {redirect, path} = item
                console.log('1111111111111')
                console.log(item);
                console.log(redirect);
                console.log(path);
                 this.pathCompile(path);
                if (redirect) {
                    this.$router.push(redirect)
                    return
                }
                this.$router.push(this.pathCompile(path))
            }
        }
    }
</script>

<style lang="less" scoped>
.app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    .no-redirect {
        color: #606266;
        cursor: text;
    }
}
</style>